module.exports = __webpack_public_path__ + "img/ai.4e6bef20.png";